<template>
  <div>
    

    <div v-if="!validation_record">
    
      <memlist-card>
        <m-row>
          <m-col lg="12">
            <p>Lägg till er domän</p>
          </m-col>
        </m-row>
        <m-row class="mt-4">
          <m-col lg="6">
            <memlist-text-input 
              v-model="input_domain"
              title="Domän"
              placeholder="example.se"
            />
          </m-col>
        </m-row>

        <m-row class="mt-4">
          <m-col lg="6">
            <memlist-button :disabled="disabled" variant="primary" @click="create_domain_clicked">Spara</memlist-button>
          </m-col>
        </m-row>
      </memlist-card>
    </div>

    <memlist-card v-else>

      <m-row>
        <m-col lg="12">
          
          <p>Logga in på ditt webbhotell och lägg tills dessa poster för din domän <b>{{domain_setting.domain}}</b>:</p>

          <h4 class="mt-8">🔁 ReturnPath (CNAME record)</h4>

          <div v-if="validation_record.ReturnPathDomainVerified">
            <memlist-inline-alert variant="success">ReturnPath {{domain_setting.domain}} är verifierad!</memlist-inline-alert>
          </div>
          <div v-else>
            <p class="mt-6"><strong>DNS Type:</strong> CNAME</p>

            <m-row>
              <m-col lg="12">
                <span style="font-weight: bold;">CNAME Host</span>
                <code-box @copy_code="code_copied" :source="`${validation_record.ReturnPathDomain}`" />
              </m-col>
            </m-row>

            <m-row class="mt-4">
              <m-col lg="12">
                <span style="font-weight: bold;" class="mt-4">CNAME Värde</span>
                <code-box @copy_code="code_copied" :source="validation_record.ReturnPathDomainCNAMEValue" />
              </m-col>
            </m-row>
            
            
            <hr />
          </div>

          

          <h4 class="mt-8">🔐 DKIM (TXT record)</h4>

          <div v-if="validation_record.DKIMVerified">
            <memlist-inline-alert variant="success">DKIM för {{domain_setting.domain}} är verifierad!</memlist-inline-alert>
          </div>
          <div v-else>
            <p class="mt-6"><strong>DNS Type:</strong> TXT</p>

            <m-row>
              <m-col lg="12">
                <span style="font-weight: bold;">TXT Host</span>
                <code-box @copy_code="code_copied" :source="`${validation_record.DKIMPendingHost}`" />
              </m-col>
            </m-row>

            <m-row class="mt-4">
              <m-col lg="12">
                <span style="font-weight: bold;" class="mt-4">TXT Värde</span>
                <code-box @copy_code="code_copied" :source="validation_record.DKIMPendingTextValue" />
              </m-col>
            </m-row>
          </div>

          <p v-if="!domain_setting.is_postmark_valid" class="mt-4">
            ✅ När dessa har lagts till på er domän kan det ta upp till 24 timmar innan alla inställningarna har uppdaterats.
          </p>
          
        </m-col>
      </m-row>
    </memlist-card>
  </div>
</template>

<script>
import axios from 'axios';
import { validate_email } from '@/core/services/email';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import CodeBox from '@/view/components/CodeBox.vue';

export default {
  name: 'VerifyEmailDomainComponent',

  mixins: [toasts],
  components: {
    CodeBox,
  },

  data() {
    return {
      input_domain: null,
      domain_setting: null,
      validation_record: null,
      emails_list: [],
      disabled: false,
    };
  },

  async created() {
    await this.get_domain();
  },

  methods: {
    code_copied(code) {
      navigator.clipboard.writeText(code).then(
        () => {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('COMMON.COPIED_TO_CLIPBOARD'));
        },
        () => {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_COPY_CLIPBOARD'));
        },
      );
    },
    async create_domain_clicked() {
      this.disabled = true;
      
      if (!await this.create_domain(this.input_domain)) {
        this.disabled = false;
      }
    },
    async create_domain(domain) {
      try {
        const res = await axios.post(`/email/domain`, { domain });
        if (res.status === 201) {
          this.domain_setting = res.data;
          this.validation_record = res.data.validation_record;
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TAB.SETTINGS_DNS.ADDED'));

          return true;
        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.SETTINGS_DNS.UNABLE_ADD'));

          return false;
        }
      } catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.SETTINGS_DNS.UNABLE_ADD'));

        return false;
      }
    },

    async get_domain() {
      try {
        const res = await axios.get(`/email/valid`);
        if (res.status === 200) {

          this.domain_setting = res.data.find(i => i.domain && i.validation_record);

          if (this.domain_setting) {
            this.validation_record = this.domain_setting.validation_record;
          }
        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMPONENT.EMAIL_VALID_DOMAIN.UNABLE_LIST'));
        }
      } catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMPONENT.EMAIL_VALID_DOMAIN.UNABLE_LIST'));
      }
    },
  },
};
</script>
